<template>
  <div class="row-value">
    <span :style="{ color }" v-if="!isEmpty">
      <span>{{ text }}</span>
      <span class="unit" v-if="unit">{{ unit }}</span>
    </span>
    <span v-else>--</span>
  </div>
</template>

<script>
export default {
  props: {
    row: {
      type: Object,
      default: () => ({})
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    val() {
      const format = this.row.format;
      const { row, data } = this;
      let val = null;
      if (Array.isArray(row.prop)) {
        val = row.prop.map(prop => data[prop]);
      } else {
        val = data[row.prop];
      }
      return format ? format(val) : val;
    },
    color() {
      if (typeof this.val === 'object') return this.val.color;
      return '';
    },
    unit() {
      return this.row.unit;
    },
    text() {
      if (typeof this.val === 'object') return this.val.des;
      return this.val;
    },
    isEmpty() {
      const v = this.val;
      return v === '' || v === undefined || v === null;
    }
  }
};
</script>

<style lang="scss">
.row-value {
  display: inline-block;
}
</style>
